import {Expose} from 'class-transformer';

export class VoucherItemMembershipPriceApiModel {
  @Expose()
  isAppliedOnOrder: boolean;

  @Expose()
  membershipLevel: number;

  @Expose()
  membershipCardTypeId: string;

  @Expose()
  membershipItemPrice: number;

  @Expose()
  membershipValue: number;
}
